import { constants } from '@/constants/constants.ts';
import { defineStore } from 'pinia';
import { ref } from 'vue';

interface Snackbar {
  key: string | null;
  active: boolean;
  color: string;
  text: string | null;
  icon: string | null;
  timeout: number;
  actions: SnackbarAction[];
}

interface SnackbarAction {
  text: string;
  href: string;
  color: string;
  icon: string;
  separator: boolean;
}

interface ErrorData {
  key: string;
  color: string;
}

const defaultSnackbar = {
  key: '',
  active: false,
  color: 'green',
  text: '',
  icon: '',
  timeout: constants.SNACKBAR.DURATION,
  actions: new Array<SnackbarAction>()
};

export const useMessageStore = defineStore('message', () => {
  const snackbar = ref<Snackbar>({
    ...defaultSnackbar
  });

  let hideTimer: ReturnType<typeof setTimeout> | null = null;

  // Messages auto-hide after `timeout` ms (defaults to SNACKBAR.DURATION).
  // Pass `timeout: -1` to keep the snackbar open until the user closes it.
  function showMessage(messageData: object) {
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
    Object.assign(snackbar.value, {
      ...defaultSnackbar,
      ...messageData,
      active: true
    });
    if (snackbar.value.timeout > 0) {
      hideTimer = setTimeout(() => {
        hideMessage();
      }, snackbar.value.timeout);
    }
  }

  function hideMessage() {
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
    snackbar.value = {
      ...defaultSnackbar
    };
  }

  function errorMessage() {
    hideMessage();
  }

  function showMessageValidateError() {
    const data: ErrorData = { key: 'form_validation_error', color: 'error' };
    showMessage(data);
  }

  return {
    // State
    snackbar,
    // Actions
    showMessage,
    hideMessage,
    showMessageValidateError,
    errorMessage
  };
});
